/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_UnpaidInputs */

const en_student_unpaid = /** @type {(inputs: Student_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unpaid`)
};

const he_student_unpaid = /** @type {(inputs: Student_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא שולם`)
};

/**
* | output |
* | --- |
* | "unpaid" |
*
* @param {Student_UnpaidInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_unpaid = /** @type {((inputs?: Student_UnpaidInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_UnpaidInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_unpaid(inputs)
	return he_student_unpaid(inputs)
});